import type { SVGProps } from 'react'

export const CloudErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_2070_5344)">
      <path
        d="M8.66666 12.0026H4.438C2.72333 12 1.33333 10.662 1.33333 9.0113C1.33333 7.3613 2.72333 6.0233 4.438 6.0233C4.7 4.84863 5.63399 3.88996 6.88799 3.50796C8.14133 3.12663 9.52533 3.3793 10.5173 4.17463C11.5093 4.96796 11.9587 6.1793 11.6973 7.35396H12.3573C13.2707 7.35396 14.0613 7.8873 14.4353 8.6633"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.6667 14.6667L11.3333 11.3334" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.3333 14.6667L14.6667 11.3334" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
)
